import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/14febd11ed764a2e4131edc63c3ba26f/1d63319f2e89e7422c7ba7489b97cad7.webp" 
                alt="Lynora Logo" 
                className="h-10 w-auto"
              />
              <span className="text-2xl font-bold text-white">Lynora</span>
            </div>
            <p className="text-sm leading-relaxed mb-6">
              International supply of electronic components, technical solutions, and logistics services for European and Ukrainian markets.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/logistics" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Logistics
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Electronic Components Import
                </a>
              </li>
              <li>
                <a href="#" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Wholesale Distribution
                </a>
              </li>
              <li>
                <a href="#" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Technical Spare Parts
                </a>
              </li>
              <li>
                <a href="#" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  International Logistics
                </a>
              </li>
              <li>
                <a href="#" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Customs Support
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-blue-400 text-lg mt-0.5"></i>
                <span className="text-sm">Roztylská 1860/1, Praha 11</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-blue-400 text-lg mt-0.5"></i>
                <a href="mailto:contact@lynora.cz" className="text-sm hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  contact@lynora.cz
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-blue-400 text-lg mt-0.5"></i>
                <span className="text-sm">Mon - Fri: 9:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800 px-6 lg:px-12 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-slate-400">
            © {currentYear} Lynora. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-sm text-slate-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-slate-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
